<div class="chat-popup-overlay" (click)="onClose()">
  <div class="chat-popup-container" (click)="$event.stopPropagation()">
    <div class="chat-popup-header">
      <div class="chat-popup-header-text">
        <h3 class="chat-popup-title">Message supplier</h3>
        <span class="chat-popup-subtitle" *ngIf="rfqId || rfqName">
          <ng-container *ngIf="rfqId !== undefined && rfqId > 0">RFQ #{{ rfqId }}</ng-container>
          <ng-container *ngIf="rfqId !== undefined && rfqId > 0 && rfqName"> &middot; </ng-container>
          <ng-container *ngIf="rfqName">{{ rfqName }}</ng-container>
        </span>
      </div>
      <button class="close-btn" (click)="onClose()" type="button" aria-label="Close">&#x2715;</button>
    </div>

    <div class="chat-popup-body">
      <div *ngIf="showChat" [id]="chatContainerId" class="talkjs-container"></div>

      <div *ngIf="showUpgradePrompt" class="upgrade-prompt">
        <div class="upgrade-icon">🔒</div>
        <h4>Premium Feature</h4>
        <p>Chat is available for Professional, Gold, and Platinum accounts.</p>
        <button class="upgrade-btn" (click)="upgradeAccount()" type="button">
          Upgrade Your Account
        </button>
        <button class="cancel-btn" (click)="onClose()" type="button">
          Maybe Later
        </button>
      </div>
    </div>
  </div>
</div>
